import { render } from "./Extras.vue?vue&type=template&id=77df86e2&scoped=true"
import script from "./Extras.vue?vue&type=script&lang=js"
export * from "./Extras.vue?vue&type=script&lang=js"

import "./Extras.vue?vue&type=style&index=0&id=77df86e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-77df86e2"

export default script